<template>
  <section>
    <modal
      v-model="open"
      :before-close="closeModal"
      class="custom-modal"
      :backdrop="false"
      :keyboard="false"
      :footer="false"
      size="lg"
    >
      <template #header><span></span></template>
      <div class="confectionModal-content">
        <h2 class="confectionModal-title">Jak chcesz złożyć zamówienie?</h2>
        <p>Zdecyduj, czy chcesz zamówić produkt zgodnie z indywidualną ofertą czy przejść do oferty standardowej.</p>
        <div class="d-flex flex-column mt-5">
          <label class="radio-tile mb-4">
            <input
              id="contract-modal-redirect"
              v-model="selectedAction"
              type="radio"
              name="contract-modal-action"
              value="redirect"
              data-action="auto-focus"
            />
            <p class="radio-tile__title">
              Zgodnie z indywidualną ofertą
            </p>
            <p class="radio-tile__description">
              Obowiązują uzgodnione ceny oraz indywidualny zakres usług.
            </p>
          </label>
          <label class="radio-tile">
            <input
              id="contract-modal-close"
              v-model="selectedAction"
              type="radio"
              name="contract-modal-action"
              value="close"
            />
            <p class="radio-tile__title">
                Zgodnie z ofertą standardową
            </p>
            <p class="radio-tile__description">
              Obowiązują ceny katalogowe i standardowy zakres usług.
            </p>
          </label>
        </div>
      </div>
      <div class="custom-modal__controls">
        <btn @click="handleModalAction" class="btn btn-primary">Kontynuuj</btn>
      </div>
    </modal>
  </section>
</template>

<script>
import { createContractPanelUrl } from '@/utils/contract/nde';
import { redirectTo } from '@/utils/navigation';

export default {
  name: 'ContractModal',
  props: {
    open: {
      type: Boolean,
      required: true,
    },
    productId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      selectedAction: 'redirect',
    };
  },
  methods: {
    handleModalAction() {
      if (this.selectedAction === 'redirect') {
        this.redirectToContractPanel();
        return;
      }

      this.closeModal();
    },
    redirectToContractPanel() {
      const url = createContractPanelUrl(this.productId);
      redirectTo(url);
    },
    closeModal() {
      this.$emit('update:open', false);
    },
  },
};
</script>

<style lang="scss" scoped>
.custom-modal ::v-deep .modal-dialog {
  max-width: 640px;
  box-sizing: content-box;
}
</style>
